<template>
  <a-icon :component="FavoriteIcon" />
</template>

<script>
const FavoriteIcon = {
  template: `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5725 8.38126C14.8678 7.99103 15.0312 7.5129 15.0312 7.01544C15.0312 6.22618 14.59 5.47911 13.8799 5.06251C13.6971 4.95528 13.4889 4.89884 13.277 4.89904H9.06172L9.16719 2.73868C9.1918 2.21661 9.00723 1.72091 8.64863 1.34298C8.47265 1.1567 8.26034 1.00849 8.02481 0.90751C7.78929 0.806528 7.53556 0.754919 7.2793 0.755872C6.36523 0.755872 5.55664 1.37111 5.31406 2.25177L3.8041 7.71857H3.79883V15.242H12.101C12.2627 15.242 12.4209 15.2104 12.5668 15.1471C13.4035 14.7902 13.9432 13.9729 13.9432 13.0658C13.9432 12.8443 13.9115 12.6264 13.8482 12.4154C14.1436 12.0252 14.307 11.5471 14.307 11.0496C14.307 10.8281 14.2754 10.6102 14.2121 10.3992C14.5074 10.009 14.6709 9.53087 14.6709 9.03341C14.6674 8.81193 14.6357 8.5922 14.5725 8.38126ZM0.96875 8.28107V14.6795C0.96875 14.9906 1.22012 15.242 1.53125 15.242H2.67383V7.71857H1.53125C1.22012 7.71857 0.96875 7.96993 0.96875 8.28107Z" fill="#333333"/>
    </svg>
  `
};

export default {
  data() {
    return {
      FavoriteIcon
    };
  }
};
</script>

<style></style>
